import { QuestionsType } from 'shared/types';

export const setBlockQuestions = () => {};

export const getSerializedBlocks = (questions: QuestionsType[]) => {
  const blocks = questions
    ?.reduce((arr: any, q: any) => {
      return [
        ...arr,
        ...(q.type_info?.meta?.block?.name
          ? [
              {
                ...q.type_info.meta.block,
                question_names: q.type_info.meta.block?.question_names || [
                  q.name,
                ],
                primary_question_name: q.name,
                type: q.type_info?.question_type,
                is_deleted: q.type_info.meta.is_deleted,
                // required: q.required,
              },
            ]
          : []),
      ];
    }, [])
    .sort(function (a, b) {
      if (b.name === 'TY') return -1;
      return a.position - b.position;
    })
    .filter((b: any) => {
      return !b.is_deleted;
    });

  const allBlocks = blocks?.filter((b: any) => b.name !== 'TY') || [];
  const thankyouBlock = blocks?.find((b: any) => b.name === 'TY');

  return {
    blocks,
    allBlocks,
    thankyouBlock,
  };
};
